import React, { useState, useEffect, useRef } from 'react';
import Spa from '../SPA/Spa.js';
import SplashScreen from '../SplashScreen/SplashScreen.js'

export default function EntryContent() {

    const getRandomArbitrary = (min, max) => {
        return Math.random() * (max - min) + min;
    }

    const [loaderValue, setLoaderValue] = useState(10);
    const [clearer, setClearer] = useState(null);
    
    useEffect(() => {
        document.title = "TiroTheTyrant - Discover The Artist";  
      }, []);

    const moveLoader = () => {
        const arb = getRandomArbitrary(5, 25);

        if (loaderValue < 100) {
            setLoaderValue((loaderValue) => loaderValue + arb < 100 ? loaderValue + arb : 100);
        } else if (loaderValue == 100) {
            setLoaderValue(1000);
        } else if (loaderValue == 1000) {
            setLoaderValue(10000);
        }
    }

    useInterval(moveLoader, 1000);
    // useEffect(() => {
    //     setInterval(moveLoader, 1000);
    // }, []);

    const showSplash = () => {
        if (loaderValue < 10000) {
            return (<SplashScreen loader={loaderValue}></SplashScreen>)
        }
    }

    return(<>
        {showSplash()}
        <Spa></Spa>
    </>)



}

function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }